import {
  findSequenceMatches,
  findApproxMatches,
  getReverseComplementSequenceString
} from "@teselagen/sequence-utils";
import sequenceSelector from "./sequenceSelector";
import { createSelector } from "reselect";
import circularSelector from "./circularSelector";
function searchLayersSelector(sequence, isCircular, isOpen, searchString, ambiguousOrLiteral, dnaOrAA, isProtein, proteinSequence, mismatchesAllowed, matchReverseComplement, tempSearchLayers = []) {
  const toReturn = [...tempSearchLayers];
  if (!searchString || !isOpen) {
    return toReturn;
  }
  if (isProtein) {
    const searchingDna = dnaOrAA === "DNA";
    const matches2 = findSequenceMatches(
      searchingDna ? sequence : proteinSequence,
      searchString,
      {
        isCircular: false,
        isProteinSequence: true,
        isAmbiguous: ambiguousOrLiteral === "AMBIGUOUS",
        // isProteinSearch: dnaOrAA !== "DNA",
        searchReverseStrand: false
      }
    ).sort(({ start }, { start: start2 }) => {
      return start - start2;
    });
    const r = searchingDna ? matches2 : matches2.map(({ start, end, ...rest }) => ({
      ...rest,
      isSearchLayer: true,
      start: start * 3,
      end: end * 3 + 2
    }));
    return [...toReturn, ...r];
  }
  if (dnaOrAA === "DNA" && ambiguousOrLiteral === "LITERAL" && mismatchesAllowed > 0) {
    const forwardMatches = findApproxMatches(
      searchString,
      sequence,
      mismatchesAllowed,
      isCircular
    ).map((match) => ({
      ...match,
      forward: true,
      originalSearchString: searchString
    }));
    let reverseMatches = [];
    if (matchReverseComplement) {
      const reverseSearchString = getReverseComplementSequenceString(
        searchString
      );
      reverseMatches = findApproxMatches(
        reverseSearchString,
        sequence,
        mismatchesAllowed,
        isCircular
      ).map((match) => ({
        ...match,
        forward: false,
        originalSearchString: searchString,
        // Map mismatch positions back to original search string offsets
        mismatchPositions: match.mismatchPositions.map(
          (p) => searchString.length - 1 - p
        )
      }));
    }
    const approxMatches = [...forwardMatches, ...reverseMatches];
    const matches2 = approxMatches.map((match) => ({
      start: match.index,
      end: match.index + match.match.length - 1,
      matchedString: match.match,
      mismatchPositions: match.mismatchPositions,
      numMismatches: match.numMismatches,
      isSearchLayer: true,
      forward: match.forward,
      originalSearchString: match.originalSearchString
    })).sort((a, b) => a.start - b.start);
    return [
      ...toReturn,
      ...matches2.map((match) => ({
        ...match,
        className: "veSearchLayer"
      }))
    ];
  }
  const matches = findSequenceMatches(sequence, searchString, {
    isCircular,
    isAmbiguous: ambiguousOrLiteral === "AMBIGUOUS",
    isProteinSearch: dnaOrAA !== "DNA",
    searchReverseStrand: matchReverseComplement
  }).sort(({ start }, { start: start2 }) => {
    return start - start2;
  });
  return [
    ...toReturn,
    ...matches.map((match) => ({
      ...match,
      forward: !match.bottomStrand,
      className: "veSearchLayer " + (match.bottomStrand ? " veSearchLayerBottomStrand" : ""),
      isSearchLayer: true
    }))
  ];
}
export default createSelector(
  sequenceSelector,
  circularSelector,
  (state) => state.findTool && state.findTool.isOpen,
  (state) => state.findTool && state.findTool.searchText,
  (state) => state.findTool && state.findTool.ambiguousOrLiteral,
  (state) => state.findTool && state.findTool.dnaOrAA,
  (state) => state.sequenceData.isProtein,
  (state) => state.sequenceData.proteinSequence,
  (state) => state.findTool && state.findTool.mismatchesAllowed,
  (state) => state.findTool && state.findTool.matchReverseComplement,
  (state) => state.temporaryAnnotations?.searchLayers,
  searchLayersSelector
);
